import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DataEntryPageComponent } from "./surveys/data-entry-page/data-entry-page.component";
import { ParentSearchByKeyPageComponent } from "./surveys/parent-search-by-key-page/parent-search-by-key-page.component";
import { SearchByKeyPageComponent } from "./surveys/search-by-key-page/search-by-key-page.component";
import { ThankYouPageComponent } from "./surveys/thank-you-page/thank-you-page.component";

const routes: Routes = [
  {
    path: "surveys/thankyou",
    component: ThankYouPageComponent,
    pathMatch: "full",
  },
  {
    path: "surveys",
    component: SearchByKeyPageComponent,
    pathMatch: "full",
  },
  {
    path: "surveys/:indicatorType",
    component: SearchByKeyPageComponent,
    pathMatch: "full",
  },
  {
    path: "surveys/:indicatorType/:languageId/:administrativeUnitSurveyId",
    component: DataEntryPageComponent,
    pathMatch: "full",
  },
  {
    path: "parentsurveys",
    component: ParentSearchByKeyPageComponent,
    pathMatch: "full",
  },
  {
    path: "parentsurveys/:surveyKey",
    component: ParentSearchByKeyPageComponent,
    pathMatch: "full",
  },
  {
    path: "parentsurveys/:indicatorType/:languageId/:administrativeUnitSurveyId",
    component: DataEntryPageComponent,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
